import { render, staticRenderFns } from "./CatalogProductSettingAttributeOptionSelection.vue?vue&type=template&id=80644fc8&scoped=true&"
import script from "./CatalogProductSettingAttributeOptionSelection.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingAttributeOptionSelection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingAttributeOptionSelection.vue?vue&type=style&index=0&id=80644fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80644fc8",
  null
  
)

export default component.exports